import React from 'react';

import './styles.scss';

const SubHeader = ({ title }) => {
  return <div className="sub-header">{title || ''}</div>;
};

export default SubHeader;
